import React from "react"

const alt = "Roland Berger"
const src = `${process.env.PUBLIC_URL}/images/${process.env.REACT_APP_COMPANY_NAME}/logo.png`

const BakerTillyBerk = props => (
    <img
        {...props}
        className="appical"
        height="140"
        width="140"
        alt={alt}
        src={src}
    />
)

export default BakerTillyBerk
